import Config from "../config/config"

export default async function overrideGeo() {
  try {
    await fetch(Config.historyService + "/geoupdate")
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/apis/geoOverride.js